import { Link } from 'react-router';

/**
 * Sandbox Home Page
 * Demonstrates routing patterns and layouts
 * 
 * TODO: Remove this page once production features are implemented
 */
export default function SandboxHomePage() {
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-4xl mx-auto">
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-8">
          <p className="text-yellow-800 text-sm font-medium">
            🏗️ <strong>Sandbox Mode:</strong> These are demonstration pages to showcase routing patterns. 
            They will be removed once production features are implemented.
          </p>
        </div>

        <h1 className="text-4xl font-bold mb-8 text-foreground">
          Web Portal 2.0 - Sandbox
        </h1>
        
        <div className="prose prose-slate dark:prose-invert mb-12">
          <p className="text-lg text-muted-foreground">
            Production-ready routing architecture with domain-driven route organization.
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          <Link
            to="/sandbox/dashboard"
            className="block p-6 bg-card border border-border rounded-lg hover:border-primary transition-colors"
          >
            <h2 className="text-xl font-semibold mb-2">Dashboard</h2>
            <p className="text-sm text-muted-foreground">
              View dashboard with nested layout
            </p>
          </Link>

          <Link
            to="/sandbox/widget"
            className="block p-6 bg-card border border-border rounded-lg hover:border-primary transition-colors"
          >
            <h2 className="text-xl font-semibold mb-2">Widget Flow</h2>
            <p className="text-sm text-muted-foreground">
              Multi-step widget without MainLayout
            </p>
          </Link>

          <Link
            to="/sandbox/browser-adapter"
            className="block p-6 bg-card border border-border rounded-lg hover:border-primary transition-colors"
          >
            <h2 className="text-xl font-semibold mb-2">💾 BrowserAdapter Demo</h2>
            <p className="text-sm text-muted-foreground">
              iframe-safe storage abstraction
            </p>
          </Link>

          <Link
            to="/sandbox/time-slot-selector"
            className="block p-6 bg-card border border-border rounded-lg hover:border-primary transition-colors"
          >
            <h2 className="text-xl font-semibold mb-2">🕐 TimeSlot Selector</h2>
            <p className="text-sm text-muted-foreground">
              Interactive booking time slot UI
            </p>
          </Link>

          <Link
            to="/sandbox/tenant-context?tenant-handle=drivingrangecollective&club-id=2"
            className="block p-6 bg-card border border-border rounded-lg hover:border-primary transition-colors"
          >
            <h2 className="text-xl font-semibold mb-2">🏢 Tenant Context Demo</h2>
            <p className="text-sm text-muted-foreground">
              Tenant/club identification service
            </p>
          </Link>

          <Link
            to="/sandbox/settings"
            className="block p-6 bg-card border border-border rounded-lg hover:border-primary transition-colors"
          >
            <h2 className="text-xl font-semibold mb-2">Settings</h2>
            <p className="text-sm text-muted-foreground">
              Simple page with MainLayout
            </p>
          </Link>
        </div>
      </div>
    </div>
  );
}
